<template>
  <div>
    <nuxt />
  </div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style>
*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
